/* import __COLOCATED_TEMPLATE__ from './checking-balances.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { NEXT_PAGE_SIZE } from '@banking/api/services/banking-unit-account-pagination';
import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
import { CHECKING_CROSS_SELL_CLICK_EVENT } from '@banking/ui/utils/launchpad/event-catalog';
import assert from '@banking/ui/utils/assert';
import { linkClickEvent } from '@dashboard/junk-drawer/utils/eventstream';
import { Action, Target, Page, getEvent } from '@banking/ui/utils/launchpad-cdp-events';
let CheckingBalances = (_class = class CheckingBalances extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "bankingUnitAccountPagination", _descriptor, this);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor2, this);
    _initializerDefineProperty(this, "events", _descriptor3, this);
    _initializerDefineProperty(this, "pageStart", _descriptor4, this);
    _initializerDefineProperty(this, "pageEnd", _descriptor5, this);
  }
  get isLoading() {
    return this.bankingUnitAccountPagination.isLoading;
  }
  get isPaginated() {
    return this.args.units.length > NEXT_PAGE_SIZE;
  }
  get paginatedBalances() {
    // Page start and end might be out of range for array, but `slice()` handles out of range indices
    return this.args.balances.slice(this.pageStart, this.pageEnd);
  }
  get showCheckingCrossSell() {
    return this.args.balances.length === 1 && this.args.balances[0].type !== AccountType.CHECKING_ACCOUNT;
  }
  trackSavingsCrossSellClickEvent() {
    this.events.track({
      kind: 'EVENTSTREAM',
      event: linkClickEvent(CHECKING_CROSS_SELL_CLICK_EVENT)
    });
    this.events.track({
      kind: 'CDP',
      event: getEvent(Action.Click, {
        target: Target.CheckingXsell
      })
    });
  }
  onActivateDebitCardUpsellClick(unitToken) {
    assert(typeof unitToken === 'string');
    this.args.activateDebitCard(unitToken);
    this.events.track({
      kind: 'CDP',
      event: getEvent(Action.Click, {
        target: Target.ActivateDebitCard,
        page: Page.ActivationUpsell,
        unitToken
      })
    });
  }
  trackActivateDebitCardUpsellView(unitToken) {
    assert(typeof unitToken === 'string');
    this.events.track({
      kind: 'CDP',
      event: getEvent(Action.View, {
        page: Page.ActivationUpsell,
        unitToken
      })
    });
  }
  refreshAccounts() {
    this.bankingAccountApi.reloadAccounts();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "bankingUnitAccountPagination", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "events", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pageStart", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pageEnd", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return NEXT_PAGE_SIZE;
  }
}), _applyDecoratedDescriptor(_class.prototype, "trackSavingsCrossSellClickEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackSavingsCrossSellClickEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onActivateDebitCardUpsellClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onActivateDebitCardUpsellClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackActivateDebitCardUpsellView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackActivateDebitCardUpsellView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshAccounts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshAccounts"), _class.prototype)), _class);
export { CheckingBalances as default };